var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "report-box" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog dialoga1",
          attrs: {
            title: " ",
            visible: _vm.sucDialogVisible,
            width: "350px",
            modal: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.sucDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-content" }, [
            _c("div", { staticClass: "dialog-content-icon-box" }, [
              _c("i", {
                staticClass: "dialog-content-icon el-icon-success",
                staticStyle: { "font-size": "50px" },
              }),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "14px",
                  color: "rgba(51, 51, 51, 1)",
                  "padding-top": "4px",
                  "line-height": "20px",
                  "padding-bottom": "8px",
                },
              },
              [
                _c("div", [_vm._v("上报成功")]),
                _c("div", [_vm._v("该企业数据录入中，请稍后再试")]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "prompt bg-1",
                staticStyle: { color: "#666666", "font-size": "12px" },
              },
              [_vm._v("数据录入所需时长为5分钟")]
            ),
            _c(
              "div",
              { staticStyle: { "padding-top": "24px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "dialog-confirm", size: "small", w88: "" },
                    on: {
                      click: function ($event) {
                        _vm.sucDialogVisible = false
                      },
                    },
                  },
                  [_vm._v("好的")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog dialoga1",
          attrs: {
            visible: _vm.errDialogVisible,
            width: "350px",
            modal: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.errDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-content" }, [
            _c("div", { staticClass: "dialog-content-icon-box" }, [
              _c("i", {
                staticClass: "dialog-content-icon el-icon-warning",
                staticStyle: {
                  "font-size": "50px",
                  color: "RGBA(237, 104, 38, 1)",
                },
              }),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "14px",
                  color: "rgba(51, 51, 51, 1)",
                  "padding-top": "4px",
                  "line-height": "20px",
                  "padding-bottom": "8px",
                },
              },
              [_c("div", [_vm._v("该企业已存在")])]
            ),
            _c(
              "div",
              { staticStyle: { "padding-top": "24px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "dialog-confirm", size: "small", w88: "" },
                    on: {
                      click: function ($event) {
                        _vm.errDialogVisible = false
                      },
                    },
                  },
                  [_vm._v("好的")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog added-dialog",
          attrs: {
            visible: _vm.addedDialogVisible,
            width: "400px",
            modal: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addedDialogVisible = $event
            },
          },
        },
        [
          _c("template", { slot: "title" }, [
            _c("div", { staticClass: "dialog-title" }, [
              _c("i", { staticClass: "el-icon-success" }),
              _vm._v("新增企业数据"),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "dialog-content" },
            [
              _c(
                "el-row",
                { attrs: { type: "flex" } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        width: "96px",
                        "text-align": "right",
                        "padding-right": "5px",
                      },
                    },
                    [_c("span", [_vm._v("您上报的 ")])]
                  ),
                  _c(
                    "el-col",
                    { staticStyle: { flex: "1" } },
                    _vm._l(_vm.addedCompanyList, function (item, i) {
                      return _c(
                        "div",
                        {
                          key: "addedCompanyList-item-" + i,
                          staticClass: "company-item",
                        },
                        [_vm._v(_vm._s(item.companyName))]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "company-tip" }, [
                _vm._v("企业数据已成功录入， 请再次查询"),
              ]),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "缺失企业名称上报",
            visible: _vm.visible,
            width: "450px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "120px",
                "label-position": "right",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "企业名称:", prop: "compony" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: { size: "small", placeholder: "请填写企业全称" },
                    model: {
                      value: _vm.ruleForm.compony,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.ruleForm,
                          "compony",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "ruleForm.compony",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "30px" },
                  attrs: { size: "small", w88: "" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.loading,
                    size: "small",
                    w88: "",
                  },
                  on: { click: _vm.onReport },
                },
                [_vm._v("上报")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showBtn,
              expression: "showBtn",
            },
          ],
          staticClass: "report-btn",
          attrs: { type: "text", size: "mini" },
          on: {
            click: function ($event) {
              _vm.visible = true
            },
          },
        },
        [_vm._v("没有找到想要的企业?点我试试")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }